import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createIntegrationProduct } from "actions/integration";
import { useCtxReferences, useProduct } from "utils/selectors";
import get from "lodash/get";
import pick from "lodash/pick";
import isEmpty from "lodash/isEmpty";
import Image from "components/Image";
import {
  INTEGRATION_OMISSION_KEYS,
  INTEGRATION_SERVICE
} from "utils/constants/metadata";
import { Formik, useFormikContext } from "formik";
import Button from "components/Form/fields/Button";
import { prepareExportToShopifyProduct } from "utils/integrations/shopify";
import { EXPORT_PRODUCT_TO_SHOPIFY_SCHEMA } from "constants/validation";
import { prepareEditProductInitialValues } from "utils/product";
import { LOGO_DIMENSIONS } from "utils/constants/image";
import ConnectionDetails from "./ConnectionDetails";

const ProductShopifyIntegrationForm = ({ uid, integration, actions }) => {
  const product = useProduct(uid);
  const { values, resetForm: resetParentForm } = useFormikContext();
  const metadata = get(values, "metadata");
  const { resource, resourceUUID, merchantAccountUUID } = useCtxReferences();
  const integrationValues = pick(metadata, INTEGRATION_OMISSION_KEYS);
  const { service } = integration;

  const showIntegrationDetails =
    service === integrationValues[INTEGRATION_SERVICE];

  const initialValues = prepareExportToShopifyProduct({
    product,
    merchantAccountUUID
  });

  return (
    <Formik
      validationSchema={EXPORT_PRODUCT_TO_SHOPIFY_SCHEMA}
      initialValues={initialValues}
      onSubmit={(formValues, formikActions) => {
        actions.createIntegrationProduct(
          {
            resource,
            resourceUUID,
            uuid: integration.uuid,
            service: service,
            data: formValues
          },
          (err, responseData) => {
            formikActions.setSubmitting(false);
            if (err) {
              formikActions.setErrors(err);
            } else if (responseData.product) {
              /**
               * After conecting a product to an integration we need to refresh the form with the new data
               */
              resetParentForm({
                values: prepareEditProductInitialValues(responseData.product)
              });
              setTimeout(
                () =>
                  formikActions.resetForm({
                    values: prepareExportToShopifyProduct({
                      product,
                      merchantAccountUUID
                    })
                  }),
                0
              );
            }
          }
        );
      }}
    >
      {({ isSubmitting, errors, submitForm }) => {
        if (showIntegrationDetails) {
          return (
            <ConnectionDetails service={service} details={integrationValues} />
          );
        } else {
          const disabled = isSubmitting || !isEmpty(errors);
          return (
            <div className="flex flex-row justify-between">
              <div className="flex-shrink-0 flex flex-row items-center">
                <Image
                  src={`/assets/integrations/${service}/logo.png`}
                  {...LOGO_DIMENSIONS[service]}
                  alt={service}
                ></Image>
              </div>
              <div className="w-100 flex justify-end">
                <Button
                  type="submit"
                  tag="button"
                  theme="slim"
                  onClick={submitForm}
                  loading={isSubmitting}
                  disabled={disabled}
                  copy={"Export"}
                />
              </div>
            </div>
          );
        }
      }}
    </Formik>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createIntegrationProduct
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ProductShopifyIntegrationForm);
